import AppLogModelBase from '../_generated/modelBases/app-log-model-base';

export default class AppLogModel extends AppLogModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
